import { tr } from './tr';
import { en } from './en';
import { es } from './es';
import { ptBR } from './pt-BR';
import { fr } from './fr';
import { de } from './de';
import { id } from './id';
import { ru } from './ru';
import { ja } from './ja';
import { hi } from './hi';
import { zhHans } from './zh-Hans';
import { bn } from './bn';

// tr temel dildir; tüm anahtarların "şekli" ondan gelir.
export type Dict = typeof tr;

// Elle yazılmış sözlükler. Bir kullanıcı burada olmayan bir dil seçerse
// İngilizceye (DEFAULT_LANG) düşülür. Yeni diller aynı editoryal kalite kapısından geçer.
export const dictionaries: Record<string, Dict> = {
  tr, en, es, 'pt-BR': ptBR, fr, de, id, ru, ja, hi, 'zh-Hans': zhHans, bn,
};

export const DEFAULT_LANG = 'en';

// Arayüzü gerçekten çevrili diller. Görüntüleme dili seçici YALNIZ bunları gösterir:
// diğerleri seçilse arayüz İngilizceye düşerdi; 195 dil vaat edip 2 sunmak yanıltıcı.
// (Mesaj otomatik çevirisi ayrı sistemdir ve tüm dilleri destekler.)
export const SUPPORTED_LANGS = Object.keys(dictionaries);

// Görüntüleme dili seçicisi için sabit, yerel liste (her dilin kendi yazımı/autonym).
// ÖNEMLİ: bilinçli olarak backend'in /messages/languages uç noktasına (195 dilin
// tamamını listeleyen, mesaj OTOMATİK ÇEVİRİSİ için ayrı bir sistem) bağımlı DEĞİL —
// önceden bu liste SUPPORTED_LANGS'e göre süzülüyordu ama backend'in kod biçimleri
// ('pt', 'zh-CN') buradaki kodlarla ('pt-BR', 'zh-Hans') birebir eşleşmediği için
// Portekizce/Çince sessizce listeden düşüyordu; ayrıca her dil değişiminde ağ
// isteğine bağımlı olmak gereksiz bir kırılganlıktı (bkz. Batuhan'ın bildirdiği
// "İngilizceye çevirince diğer diller gözükmüyor" — ağ/zamanlama kaynaklı olabilir).
// Yalnızca 11 dil olduğu için sabit liste hem daha basit hem daha sağlam.
export const DISPLAY_LANGUAGES: { code: string; name: string }[] = [
  { code: 'tr', name: 'Türkçe' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'español' },
  { code: 'pt-BR', name: 'Português (Brasil)' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'id', name: 'Indonesia' },
  { code: 'ru', name: 'русский' },
  { code: 'ja', name: '日本語' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'zh-Hans', name: '中文（简体）' },
  { code: 'bn', name: 'বাংলা' },
];
